import { DisputeStatus, ReturnsStatus } from '../../../../typings/returns';
import { USER_TYPE } from '../constants';

const useGetReturnsStatusKeyName = (
  userType: USER_TYPE,
  status: ReturnsStatus | DisputeStatus,
  deliveryMethod: string,
  isInfo = false,
) => {
  const withInfo = isInfo ? 'info_' : '';
  const statusesDifferentForBuyerD2D = ['DELIVERY_LABEL_RECEIVED'];
  const statusesDifferentForSellerD2D = [
    'DELIVERY_FEE_PAID',
    'DELIVERY_LABEL_REQUESTED',
    'DELIVERY_LABEL_RECEIVED',
  ];
  const forD2D =
    deliveryMethod === 'DOOR_TO_DOOR' &&
    ((userType === USER_TYPE.BUYER && statusesDifferentForBuyerD2D.includes(status)) ||
      (userType === USER_TYPE.SELLER && statusesDifferentForSellerD2D.includes(status)))
      ? '_d2d'
      : '';

  return `dlv_returns_status_${withInfo}${userType}${forD2D}_${status.toLowerCase()}`;
};

export default useGetReturnsStatusKeyName;
